var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Utils {
    /**
     * Performs an asynchronous API call using the Fetch API.
     *
     * @param {string} url - The URL to send the API request to.
     * @param {string} method - The HTTP method for the API request (default: 'GET').
     * @param {any} postData - Optional data to send in the request body for methods like POST.
     * @returns {Promise<any>} A promise that resolves to the API response data.
     * @throws {Error} If a network error occurs or the response status is not OK.
     */
    static apiCall(url, method = "GET", postData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const options = {
                    method,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                };
                if (postData) {
                    options.body = JSON.stringify(postData);
                }
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error("Network error");
                }
                const data = yield response.json();
                return data;
            }
            catch (error) {
                console.error("Error fetching data:", error);
                throw error;
            }
        });
    }
    static upload(url, path, fileInput, onProgress, onComplete, onError) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const xhr = new XMLHttpRequest();
                xhr.open("POST", url);
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        if (onComplete) {
                            onComplete(data);
                        }
                    }
                    else {
                        console.error("Network error");
                        if (onError)
                            onError(xhr);
                    }
                };
                xhr.onerror = (ev) => {
                    console.error("Error uploading data", ev);
                    if (onError)
                        onError(ev);
                };
                if (onProgress) {
                    xhr.upload.onprogress = onProgress;
                }
                const formData = new FormData();
                const file = fileInput.files[0];
                if (file) {
                    formData.append("path", path);
                    formData.append("fileName", file.name);
                    formData.append("file", file, file.name);
                }
                xhr.send(formData);
            }
            catch (error) {
                console.error("Error uploading data:", error);
                if (onError)
                    onError(error);
            }
        });
    }
    /**
     * Checks if an object is not undefined and not null.
     *
     * @param {any} obj - The object to check.
     * @returns {boolean} Returns true if the object is not undefined and not null, otherwise false.
     */
    static isOk(obj) {
        return typeof obj !== "undefined" && obj !== null;
    }
    /**
     * Finds the closest ancestor element of a given element that matches a specified selector.
     *
     * @param {HTMLElement} element - The starting element for the search.
     * @param {string} parentSelector - The selector to match against ancestor elements.
     * @returns {HTMLElement | null} Returns the closest ancestor element matching the selector, or null if not found.
     */
    static closest(element, parentSelector) {
        while (element && element.tagName !== "body") {
            if (element instanceof HTMLElement) {
                if (parentSelector.startsWith(".")) {
                    // If parentSelector starts with '.', it's a class selector
                    if (element.classList.contains(parentSelector.slice(1))) {
                        return element;
                    }
                }
                else if (element.matches(parentSelector)) {
                    // If it's not a class selector, use element.matches with the full selector
                    return element;
                }
            }
            element = element.parentNode;
        }
        return null;
    }
    /**
     * Formats a string by replacing placeholders like {0}, {1}, etc. with provided values.
     *
     * @param {string} str - The string containing placeholders.
     * @param {...any} values - Values to replace the placeholders with.
     * @returns {string} Returns the formatted string with replaced values.
     * @example
     * // Example usage:
     * const template = "Hello, {0}! Today is {1}.";
     * const formatted = YourClassName.format(template, "SABIS", "Monday");
     * console.log(formatted); // Output: "Hello, Alice! Today is Monday."
     */
    static format(str, ...values) {
        return str.replace(/\{(\d+)\}/g, (match, index) => {
            const valueIndex = parseInt(index);
            return values[valueIndex] !== undefined ? values[valueIndex] : match;
        });
    }
    static modal(modalType, header, text, closeText = "Close") {
        const overlay = document.createElement("div");
        overlay.classList.add("modal-overlay");
        const popup = document.createElement("div");
        popup.classList.add("modal");
        popup.classList.add(modalType);
        const heading = document.createElement("h2");
        heading.textContent = header;
        const paragraph = document.createElement("div");
        paragraph.classList.add("body");
        paragraph.innerHTML = text;
        const closeButton = document.createElement("button");
        closeButton.textContent = closeText;
        closeButton.addEventListener("click", () => {
            document.body.removeChild(overlay);
        });
        popup.appendChild(heading);
        popup.appendChild(paragraph);
        popup.appendChild(closeButton);
        overlay.appendChild(popup);
        document.body.appendChild(overlay);
        setTimeout(() => {
            overlay.classList.add("visible");
        }, 20);
    }
    static isImage(fileName) {
        const imageRegex = /.(jpg|png|gif)$/;
        return imageRegex.test(fileName);
    }
}
